import { User } from "api/api";
import moment from "moment";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SnackbarState {
  message: string;
  type: "info" | "success" | "warning" | "error";
  opened: boolean;
  open: ({
    message,
    type,
  }: {
    message: string;
    type: "info" | "success" | "warning" | "error";
  }) => void;
  close: () => void;
}

export const useSnackbar = create<SnackbarState>((set) => ({
  message: "",
  type: "info",
  opened: false,
  open: ({ message, type }) => {
    set((state) => ({ ...state, message, type, opened: true }));
    setTimeout(() => {
      set((state) => ({ ...state, opened: false }));
    }, 5000);
  },
  close: () => {
    set((state) => ({ ...state, opened: false }));
  },
}));

interface RecaptchaState {
  recaptchaFailed: boolean;
  setRecaptchaFailed: (recaptchaFailed: boolean) => void;
}

export const useRecaptcha = create<RecaptchaState>((set) => ({
  recaptchaFailed: false,
  setRecaptchaFailed: (payload) => {
    set((state) => ({ ...state, recaptchaFailed: payload }));
  },
}));

export const useEventFilterState = create()((set, get) => ({
  location: "",
  locationAvailable: false,
  dateRangeName: "This week",
  dateRange: {
    start: moment().startOf("week").toDate(),
    end: moment().endOf("week").toDate(),
  },
  selectedCategories: [],
}));

interface AuthState {
  token: string | null;
  setToken: (token: string | null) => void;
  profile: Partial<User> | null;
  setProfile: (profile: Partial<User> | null) => void;
}

export const useAuthState = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      setToken: (token: string | null) => {
        set((state) => ({ ...state, token }));
      },
      profile: null,
      setProfile: (profile: Partial<User> | null) => {
        set((state) => ({ ...state, profile }));
      },
    }),
    {
      name: "authState", // unique name
    }
  )
);
